var $grid;

// flatten object by concatting values
function concatValues( obj ) {
  var value = '';
  for ( var prop in obj ) {
    value += obj[ prop ];
  }
  return value;
}


jQuery(document).ready(function($) { 


   var loycoHeader = document.querySelector("header.site-header");

  /**************************************************************************************************************/
  /************************** HEADROOM ********************************/
  /**************************************************************************************************************/



  var options = {
      offset : 60,

      // scroll tolerance in px before state changes
   //   tolerance : 0,
      // or you can specify tolerance individually for up/down scroll
      tolerance : {
          up : 5,
          down : 0
      }
  };

  var headroom  = new Headroom(loycoHeader,options);

  // initialise
  headroom.init();


      /* Accessibility / Light / Dark and Contraste thème */
 
    function calculateSettingAsThemeString({ localStorageTheme}) {

      if (localStorageTheme !== null) {
        return localStorageTheme;
      }

      return "standard";
    }


    /**
    * Utility function to update the theme setting on the html tag
    */
    function updateThemeOnHtmlEl({ theme }) {
      document.querySelector("html").setAttribute("data-theme", theme);
        buttonsChangeTheme.forEach(item => {
        item.classList.remove("selected");
      });
        document.querySelector('[data-theme-toggle][data-theme="'+theme+'"]').classList.add("selected");
    }

    /**
    * On page load:
    */


    /**
    * 1. Grab what we need from the DOM and system settings on page load
    */
    const buttonsChangeTheme = document.querySelectorAll("[data-theme-toggle]");
    const localStorageTheme = localStorage.getItem("theme");

    /**
    * 2. Work out the current site settings
    */
    let currentThemeSetting = calculateSettingAsThemeString({ localStorageTheme });

    /**
    * 3. Update the theme setting and button text accoridng to current settings
    */
    updateThemeOnHtmlEl({ theme: currentThemeSetting });


    /**
    * 4. Add an event listener to toggle the theme
    */
    buttonsChangeTheme.forEach(item => {
      item.addEventListener('click', event => {
        //handle click
        const newTheme = item.dataset.theme;
        localStorage.setItem("theme", newTheme);
        updateThemeOnHtmlEl({ theme: newTheme });
        currentThemeSetting = newTheme;
    
      });
    });


     /* menu mobile - add */
  $( "#primary-menu > li.menu-item-has-children" ).each(function( index ) {
     var $link_txt =  $( this ).find('> a').text();
     $( this ).children('ul.sub-menu').prepend('<li class="title_sub_menu_back"><i class="icon-prev"></i>'+$link_txt+'</li>');
    
  }); 

  $( ".menu-toggle" ).click(function() {
    $('#primary-menu > li.menu-item-has-children').removeClass('focus');
  });

  $( ".title_sub_menu_back" ).click(function() {
    $(this).parent().parent().removeClass('focus');
  });

/*****************************************************/
  /************** CHANGE SIZE TYPOGRAPHIE ****/
/*****************************************************/

function calculateSettingSize({ localStorageSize}) {
    if (localStorageSize !== null) {
      return localStorageSize;
    }
    return "100";
}


 function updateSizeOnHtmlEl({ size }) {
   // document.querySelector("html").setAttribute("data-size", size+'%');
   document.querySelector("html").style.fontSize = size+'%';


   if(parseInt(size) > 125){
    document.querySelector('[data-size="more"]').disabled = true;
   }else{
      document.querySelector('[data-size="more"]').disabled = false;
   }

   if(parseInt(size) < 75){
    document.querySelector('[data-size="less"]').disabled = true;
   }else{
      document.querySelector('[data-size="less"]').disabled = false;
   }

    if(parseInt(size) == 100){
    document.querySelector('[data-size="standard"]').disabled = true;
   }else{
      document.querySelector('[data-size="standard"]').disabled = false;
   }



    //   buttonsChangeTheme.forEach(item => {
    //     item.classList.remove("selected");
    // });
    //   document.querySelector('[data-theme-toggle][data-theme="'+theme+'"]').classList.add("selected");
 }

const buttonsChangeSize = document.querySelectorAll("[data-change-size]");
const localStorageSize = localStorage.getItem("size");

let currentThemeSize = calculateSettingSize({ localStorageSize});
updateSizeOnHtmlEl({size:currentThemeSize});

buttonsChangeSize.forEach(item => {
    item.addEventListener('click', event => {
      //handle click
      const SizeDirection = item.dataset.size;
      if(SizeDirection == 'standard') newSize = 100; 
      else if(SizeDirection == 'less') newSize = parseInt(currentThemeSize)-10; else newSize = parseInt(currentThemeSize)+10;
      localStorage.setItem("size", newSize);
      updateSizeOnHtmlEl({ size: newSize });
      currentThemeSize = newSize;
    });
});


  /********************************/
  /* ********* HEADER HOME PAGE GALLERY *******/

  var swiper_headerGallery = new Swiper('.swiper-headerGallery', {
     // If we need pagination
       spaceBetween: 0, // try '5%' if you want
       slidesPerView: 1,
       loop: true,
       allowTouchMove: false,
       centeredSlides:false,
        autoplay: {
           delay: 5500,
           disableOnInteraction: true,
       },

      pagination: {
         el: '.swiper-pagination-headerGallery',
         clickable: true
       }
   });   


    /********************************/
  /* ********* EXHIBITION NOW / PAGE HOME *******/

   var swiper_ExhibitionNow_home = new Swiper('.swiper-ExhibitionNow-home', {

     // If we need pagination
       spaceBetween: 20,
       slidesPerView: 1.3,
       loop: true,
       allowTouchMove: true,
        autoplay: {
           delay: 5500,
           disableOnInteraction: true,
       },
       breakpoints: {
            1600: { // a partir de 769
              spaceBetween: 100,
              slidesPerView: 3.6,
            },

            1400: { // a partir de 769
              spaceBetween: 50,
              slidesPerView: 3.1,
            },

             1024: { // a partir de 10224
              spaceBetween: 80,
              slidesPerView: 2.6,
            },
            768: { // a partir de 10224
              spaceBetween: 60,
              slidesPerView: 2.6,
            },
            550: { // a partir de 10224
              spaceBetween: 60,
              slidesPerView: 1.8,
            },
            425: { // a partir de 10224
              spaceBetween: 40,
              slidesPerView: 1.6,
            }
      
      },
       navigation: {
            nextEl: '.only-exhibition-next',
            prevEl: '.only-exhibition-prev'
      },
    
      pagination: {
        el: '.ExhibitionNow-pagination-render',
        type:"fraction",
         renderFraction: function (currentClass, totalClass) {
            return '<span class="' + currentClass + '"></span>' + '/' + '<span class="' + totalClass + '"></span>';
      },

       
    }

   });   


  /********************************/
  /* ********* EXHIBITION NOW / PAGE PROGRAM *******/

   var swiper_ExhibitionNow_program = new Swiper('.swiper-ExhibitionNow-program', {

     // If we need pagination
       spaceBetween: 20,
       slidesPerView: 1.3,
       loop: true,
       allowTouchMove: true,
        autoplay: {
           delay: 5500,
           disableOnInteraction: true,
       },
       breakpoints: {
            1600: { // a partir de 769
              spaceBetween: 100,
              slidesPerView: 4.6,
            },

            1400: { // a partir de 769
              spaceBetween: 100,
              slidesPerView: 3.6,
            },

            1024: { // a partir de 10224
              spaceBetween: 60,
              slidesPerView: 3.6,
            },
            768: { // a partir de 10224
              spaceBetween: 60,
              slidesPerView: 2.6,
            },
            550: { // a partir de 10224
              spaceBetween: 60,
              slidesPerView: 1.8,
            },
            425: { // a partir de 10224
              spaceBetween: 40,
              slidesPerView: 1.6,
            }
      
      },
       navigation: {
            nextEl: '.only-exhibition-next',
            prevEl: '.only-exhibition-prev'
      },
    
      pagination: {
        el: '.ExhibitionNow-pagination-render',
        type:"fraction",
         renderFraction: function (currentClass, totalClass) {
            return '<span class="' + currentClass + '"></span>' + '/' + '<span class="' + totalClass + '"></span>';
      },

       
    }

   });   



  /// 
    // UPDATE WIDTH M EN FONCTION DE LA LARGEUR DE L'ECRAN //
  function updateWidthsMdeco() {
    // Récupère le SVG et l’élément à redimensionner
    const svg = document.querySelector(".Mbg");
    const deco = document.querySelector(".HomeInserts-DecoM");

    if (!svg || !deco) return; // sécurité si les éléments n’existent pas

    // Largeur réelle du SVG en pixels
    const svgWidth = svg.getBoundingClientRect().width;

    // Calcul de 8% pour l'autre élément
    const decoWidth = svgWidth * 0.177;

    // Applique la largeur en pixels
    deco.style.width = `${decoWidth}px`;
  }

  // Met à jour au chargement
  window.addEventListener("load", updateWidthsMdeco);

  // Met à jour à chaque resize
  window.addEventListener("resize", updateWidthsMdeco);




    /*******************/
     /* FILTER */
    /*******************/

    var coll = document.getElementsByClassName("collapsible");
    var i;

    for (i = 0; i < coll.length; i++) {
      coll[i].addEventListener("click", function() {
        this.classList.toggle("active");
        this.parentNode.classList.toggle("active_filters");
        // if(this.parentNode.classList.contains('active_filters')){

        // }
        var content = this.nextElementSibling;
        if (content.style.maxHeight){
          content.style.maxHeight = null;
        } else {
          content.style.maxHeight = content.scrollHeight + "px";
        }
      });
    }


    /*******************/
     /* GRID PROGRAMME */
    /*******************/


   if (document.querySelectorAll('#EventsOP').length > 0)
    {
        var grid_isotope;
        var string_number_filter = document.getElementById('number-filter');
         $grid = $('.grid-eventoa').imagesLoaded( function() {
            grid_isotope = $grid.isotope({
            itemSelector: '.eventoa-item',
            percentPosition: true,
            layoutMode: 'fitRows',
             fitRows: {
                 columnWidth: '.grid-eventoa-sizer',
                 gutter: '.gutter-eventoa-sizer',
             }

          });
        });

        
      // une fois que les images sont finies de chargées
    $(window).on('load', function(){
      //$grid.isotope('reloadItems').isotope({sortBy: 'original-order'}); 
     });

     // ISOTOPE GRID //

        var filters = {};
        var $buttonGroup, filterGroup, filterValue;

        $( ".BlockFilter-List button").click(function() {

            $buttonGroup = $(this).parents('.BlockFilter-List');
            filterGroup = $buttonGroup.attr('data-filter-group');
              // set filter for group
            filters[ filterGroup ] = $(this).attr('data-filter');
            // combine filters
            filterValue = concatValues( filters );
            //console.log(filterValue);

            $(this).parents('.BlockFilter-List').find('button').removeClass('active');
             $(this).addClass('active');

             $grid.isotope({ filter: filterValue});

            string_number_filter.textContent = "("+grid_isotope.data('isotope').filteredItems.length+")";
            var elm = string_number_filter;
            var newone = elm.cloneNode(true);
            string_number_filter = newone;
            elm.parentNode.replaceChild(newone, elm);

             return false;

        });


      }




  /********************************/
  /* ********* GALLERY SINGLE PAGE MUSEUM *******/

  var swiper_GalleryMuseum = new Swiper('.swiper-GalleryMuseum', {
     // If we need pagination
       spaceBetween: 0, // try '5%' if you want
       slidesPerView: 1,
       loop: true,
       allowTouchMove: false,
       centeredSlides:false,
        autoplay: {
           delay: 5500,
           disableOnInteraction: true,
       },

      pagination: {
         el: '.swiper-pagination-GalleryMuseum',
         clickable: true
       }
   });   



    ////////////////
    //// GLOBAL accordion 
   ///////////////
   $('.accordion-section-content:not(.first)').hide();
   $('.acc-item.first').addClass('active');
    //$('#content_s_1').parent().find('h2 a').addClass('active');

   //$('.accordion-section-content').hide();
    // accordion SECTION 
    function close_accordion_section() {
        $('.accordion-page .accordion-section-title').removeClass('active');
        $('.accordion-page .accordion-section-content').slideUp(300).removeClass('open');
    }

    $('.accordion-section-title').click(function(e) {
        // Grab current anchor value
        var currentAttrValue = $(this).attr('aria-controls');
      
        var parentActiveAcc = $(this).parent().parent().parent().attr('data-accordion-id');

         $(parentActiveAcc + ' .acc-item.active .acc-item-Content').not('#'+currentAttrValue).slideUp(300);
         $(parentActiveAcc + ' .acc-item.active .accordion-section-title:not([aria-controls="'+currentAttrValue+'"])').attr('aria-expanded', 'false');
         $(parentActiveAcc + ' .acc-item.active .acc-item-Content').not('#'+currentAttrValue).parent().removeClass('active'); 

        if($(this).parent().parent().hasClass('active')) {
          
           // close_accordion_section();
            $(this).attr('aria-expanded', 'false');
            $('.accordion-page ' + '#'+currentAttrValue).slideUp(300).removeClass('open');
            $(this).parent().parent().removeClass('active');

        }else {
          //  close_accordion_section();
 
            // Add active class to section title
            $(this).parent().parent().addClass('active');
            $(this).attr('aria-expanded', 'true');
            // Open up the hidden content panel
            $('.accordion-page ' + '#'+currentAttrValue).slideDown(300).addClass('open');
            if($('#'+currentAttrValue+'-number').length){
              let to_number = $('#'+currentAttrValue+'-number').attr('data-number');
              let demo = new countUp.CountUp(currentAttrValue+'-number', to_number, options_count);
              demo.start();
            } 
            
        }
 
        e.preventDefault();
    });
    // FIN accordion //
    ////////////////////
      

  /**********************************************************************/
    /*************** Galerie d'image // Flexible  ****************/
  /**********************************************************************/

   

   $( ".mF_Gallery .gallerie-thumb" ).each(function( index ) {
      var id_galerie_masonry = $(this).attr('id');
        lightGallery(document.getElementById(id_galerie_masonry), {
           plugins: [lgThumbnail],
           selector: '.item-img',
           subHtmlSelectorRelative: true,
           thumbnail: true,
           mobileSettings: {
            controls: true,
            showCloseIcon: true,
            download: false
          }
       });
   });


   var top_scroll = 0;
   $(document).on("click", ".link_to_scroll", function(e) {
     var item_split = $(this).attr("href");
     var offsetTop = $(item_split).offset().top-top_scroll;

      $('html, body').stop().animate({ 
          scrollTop: offsetTop
      }, 600);
      e.preventDefault();
  });



}); // fin ready menu


  /**********************************************************************/
  /********************** CLOSE ALERT / LOCALSTORAGE **************************/
  /**********************************************************************/

document.addEventListener("DOMContentLoaded", function () {
  const banner = document.getElementById("alert-banner");
  if (!banner) return;

  const closeBtn = document.querySelector(".close-alert");
  if (!closeBtn) return;

  const version = banner.dataset.alertVersion || "1";
  const storageKey = "alertClosed_" + version;

  // Si déjà fermé pour cette version → ne pas afficher
  if (localStorage.getItem(storageKey) === "true") {
    banner.classList.add("hidden");
  }

  closeBtn.addEventListener("click", function () {
    banner.classList.add("closing");

    banner.addEventListener("transitionend", function handler() {
      banner.classList.add("hidden");
      banner.classList.remove("closing");
      banner.removeEventListener("transitionend", handler);
    });

    // On stocke la fermeture pour CETTE version
    localStorage.setItem(storageKey, "true");
  });
});


  /**********************************************************************/
  /********************** MARK LAST COLUMN FOR FLOW JOURNAL **************************/
  /**********************************************************************/


function markLastInColumns(containerSelector, itemSelector) {
  const container = document.querySelector(containerSelector);
  if (!container) return;
  const items = Array.from(container.querySelectorAll(itemSelector));
  if (!items.length) return;

  items.forEach(it => it.classList.remove('last-in-column'));

  const rectContainer = container.getBoundingClientRect();
  const tolerance = 6;
  const clusters = [];

  items.forEach(item => {
    const r = item.getBoundingClientRect();
    const left = Math.round(r.left - rectContainer.left);
    let cluster = clusters.find(c => Math.abs(c.left - left) <= tolerance);
    if (!cluster) {
      cluster = { left, items: [] };
      clusters.push(cluster);
    }
    cluster.items.push({ item, top: r.top });
  });

  clusters.forEach(c => {
    const last = c.items.reduce((a, b) => (a.top >= b.top ? a : b));
    last.item.classList.add('last-in-column');
  });
}

// Exécution au chargement
document.addEventListener("DOMContentLoaded", () => {
  markLastInColumns(".MoreInfo", ".MoreInfo-Item");
});

// Recalcul si la fenêtre est redimensionnée (responsive)
window.addEventListener("resize", () => {
  markLastInColumns(".MoreInfo", ".MoreInfo-Item");
});



  /**********************************************************************/
  /********************** BTN POUR AJOUTER AU FAVORI UN EVT D'OPEN AGENDA **************************/
  /**********************************************************************/

document.addEventListener("DOMContentLoaded", () => {
  const FAVORITES_KEY = "myFavorites"; // nom utilisé dans localStorage

  // Récupère les favoris actuels ou tableau vide
  const getFavorites = () => {
    return JSON.parse(localStorage.getItem(FAVORITES_KEY)) || [];
  };

  // Sauvegarde la liste
  const saveFavorites = (favorites) => {
    localStorage.setItem(FAVORITES_KEY, JSON.stringify(favorites));
  };

  // Vérifie si un event est déjà en favoris
  const isFavorite = (id) => {
    return getFavorites().includes(id);
  };

  // Ajoute ou supprime un favori
  const toggleFavorite = (id) => {
    let favorites = getFavorites();
    if (favorites.includes(id)) {
      favorites = favorites.filter(fav => fav !== id); // suppression
    } else {
      favorites.push(id); // ajout
    }
    saveFavorites(favorites);
  };

  // Gestion du clic sur les boutons
  document.querySelectorAll(".button-favorite").forEach(button => {
    const article = button.closest(".EventResume");
    const eventId = article.getAttribute("id");
    const spanTooltip = button.querySelector(".tooltiptext");

    // État initial si déjà favori
    if (isFavorite(eventId)) {
      button.classList.add("to-remove");
      spanTooltip.textContent = button.dataset.txtRemove;
    }

    button.addEventListener("click", () => {
      toggleFavorite(eventId);

      if (isFavorite(eventId)) {
        button.classList.add("to-remove");
        spanTooltip.textContent = button.dataset.txtRemove;
      } else {
        button.classList.remove("to-remove");
        spanTooltip.textContent = button.dataset.txtAdd;
      }
    });
  });
});